export default class NumericValidation {
    constructor (dto) {
        this.mask = dto ? dto.Mask : ''
        this.minVal = dto ? dto.MinVal : ''
        this.maxVal = dto ? dto.MaxVal : ''
        this.scale = dto ? dto.Scale : ''
    }
}
